var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "a",
    {
      staticClass: "item",
      attrs: { href: _vm.$router.options.base + "propiedades/" + _vm.id }
    },
    [
      (_vm.status || _vm.reappraised) && _vm.status == "available"
        ? _c("span", { staticClass: "item-featured" }, [
            _vm._v(
              "\n\t\t" +
                _vm._s(
                  !_vm.highlight && _vm.reappraised ? "RETASADO" : "DESTACADA"
                ) +
                "\n\t"
            )
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.status_str
        ? _c("span", { staticClass: "item-status" }, [
            _vm._v(_vm._s(_vm.status_str))
          ])
        : _vm._e(),
      _vm._v(" "),
      _c("div", {
        staticClass: "item-figure embed-responsive embed-responsive-16by9",
        style: "background-image: url(" + _vm.img + ")"
      }),
      _vm._v(" "),
      _c("div", { staticClass: "item-pricing" }, [
        _vm.price
          ? _c("span", { staticClass: "item-price" }, [
              _vm._v(_vm._s(_vm.currency.name) + " " + _vm._s(_vm.price))
            ])
          : _vm._e(),
        _vm._v(" "),
        _c("span", { staticClass: "item-type" }, [
          _vm._v(
            _vm._s(_vm.property_type.name + " en " + _vm.transaction_type.name)
          )
        ])
      ]),
      _vm._v(" "),
      _vm.rooms || _vm.bedrooms || _vm.bathrooms || _vm.m2_covered || _vm.m2
        ? _c("ul", { staticClass: "item-details" }, [
            _vm.rooms
              ? _c("li", { staticClass: "item-detail" }, [
                  _c("i", { staticClass: "icon-home" }),
                  _vm._v(" " + _vm._s(_vm.rooms) + " Ambientes\n\t\t")
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.bedrooms
              ? _c("li", { staticClass: "item-detail" }, [
                  _c("i", { staticClass: "icon-bed" }),
                  _vm._v(" " + _vm._s(_vm.bedrooms) + " Dorm\n\t\t")
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.bathrooms
              ? _c("li", { staticClass: "item-detail" }, [
                  _c("i", { staticClass: "icon-droplet" }),
                  _vm._v(" " + _vm._s(_vm.bathrooms) + " Baños\n\t\t")
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.m2_covered || _vm.m2
              ? _c("li", { staticClass: "item-detail" }, [
                  _c("i", { staticClass: "icon-codeopen" }),
                  _vm._v(
                    "\n\t\t\t" +
                      _vm._s(_vm.m2 ? "Sup. " + _vm.m2 + "m²" : "") +
                      "\n\t\t\t" +
                      _vm._s(_vm.m2_covered && _vm.m2 ? "/" : "") +
                      "\n\t\t\t" +
                      _vm._s(_vm.m2_covered ? _vm.m2_covered + "m² Cub." : "") +
                      "\n\t\t"
                  )
                ])
              : _vm._e()
          ])
        : _vm._e(),
      _vm._v(" "),
      _c("h4", { staticClass: "item-title" }, [_vm._v(_vm._s(_vm.title))]),
      _vm._v(" "),
      _c("address", { staticClass: "item-address" }, [
        _c("i", { staticClass: "icon-location" }),
        _vm._v(
          " " +
            _vm._s(_vm.address) +
            " " +
            _vm._s(_vm.address_number) +
            ", " +
            _vm._s(_vm.city.name) +
            "\n\t"
        )
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }